import { defineComponent as _defineComponent } from 'vue'
import "firebase/firestore";
import "firebase/messaging";
import AuthenticatingComponent from "./components/authenticating.component.vue";
import InstallUpdateComponent from "./components/dialogs/install-update-dialog.vue";
import { useManageAppUpdates } from "./composables/use-manage-app-updates";
import store from "@/store";

import { onMounted } from "vue";
// @ts-ignore
// import CoolLightBox from "vue-cool-lightbox";
// import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

// const index = ref<number | null>(null);
// const items = [
//   "https://victoria-university-elearning.s3.us-east-1.amazonaws.com/general_resources/rajiv-legacy.webp",
// ];


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isStagingEnv = process.env.VUE_APP_IS_STAGING;
const APP_VERSION = process.env.VUE_APP_VERSION;
const isDev =
  process.env.VUE_APP_IS_STAGING || process.env.NODE_ENV !== "production";

const appVersion = isDev ? "Development" : `Version 3.${APP_VERSION}`;
const { installUpdateDialogVisible, reloadPage } = useManageAppUpdates();

onMounted(() => {
  // if (process.env.VUE_APP_NO_COOL_LIGHT_BOX_POPUP != "true") {
  //   setTimeout(() => {
  //     index.value = 0;
  //   }, 1000);
  // }
});

return { __sfc: true,isStagingEnv, APP_VERSION, isDev, appVersion, installUpdateDialogVisible, reloadPage, AuthenticatingComponent, InstallUpdateComponent, store }
}

})